module.exports = __webpack_public_path__ + "img/HamburgerMenu.7f67d495.svg";